import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ current, total }) => {
  const percent = total > 0 ? (current / total) * 100 : 0;

  return (
    <div className="progress-bar-container">
      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${percent}%` }}
        ></div>
      </div>
      <div className="progress-text">
        {current} / {total}
      </div>
    </div>
  );
};

export default ProgressBar;
